var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.26763 21.9015C3.25203 21.9015 3.23763 21.9015 3.22083 21.9003C2.84282 21.8811 2.47202 21.7995 2.11922 21.6567C0.382806 20.9511 -0.4548 18.9675 0.249605 17.2323L9.03487 1.84099C9.33727 1.29379 9.79567 0.835384 10.3549 0.525782C11.9929 -0.381424 14.0641 0.21498 14.9701 1.85179L23.6978 17.1255C23.8922 17.5827 23.975 17.9547 23.9954 18.3339C24.0422 19.2411 23.7326 20.1111 23.1254 20.7843C22.5182 21.4575 21.6842 21.8547 20.7782 21.9003L3.35403 21.9015H3.26763Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 14.9734C12.5776 14.9734 13.0492 15.4414 13.0492 16.0163C13.0492 16.6079 12.5776 17.0795 11.9992 17.0795C11.4208 17.0795 10.9492 16.6079 10.9492 16.0294C10.9492 15.4474 11.4208 14.9734 11.9992 14.9734ZM11.9992 7.48047C12.5776 7.48047 13.0492 7.95207 13.0492 8.53048V11.9241C13.0492 12.5037 12.5776 12.9741 11.9992 12.9741C11.4208 12.9741 10.9492 12.5037 10.9492 11.9241V8.53048C10.9492 7.95207 11.4208 7.48047 11.9992 7.48047Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.7b4dd12894dd9b5c2f437d66db143c86.svg";
export { ForwardRef as ReactComponent };